<script>
  import Vue from 'vue';
  import VueResource from 'vue-resource';

  Vue.use(VueResource);

  export default {
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {
      
    },
    mounted() {

    },
  }
</script>

<template>
  <div style="height: 100vh;">
    <router-view></router-view> 
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/componentes/LayoutChat.vue